import { Provider } from 'react-redux';

import { store } from './app/store';
import './assets/scss/fonts.scss';
import './assets/scss/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import '@turnpike/portal-data-grid/styles.css';
import { AppRouter } from './router';

export const App = () => {
	return (
		<Provider store={store}>
			<AppRouter />
		</Provider>
	);
};
